let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4WHWP")).then(() => parcelRequire('4Oadt'));